import { TranslateLoader, TranslationObject } from '@ngx-translate/core';

import { Observable } from 'rxjs';

import { ApiService } from '../services';

export class TranslationLoader implements TranslateLoader {
  constructor(private apiService: ApiService) {}

  getTranslation(language: string): Observable<TranslationObject> {
    return this.apiService.getTranslation({ application: localStorage.getItem('domain'), language });
  }
}
